import { isNullish } from '@/utils/helper'
import { Text, Input, Tooltip } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

const InputCell = ({
  getValue,
  table,
  row: { index: rowIndex },
  column: { id: columnId },
  type = 'text',
  extraDisable = false,
  handleOnBlur = () => {},
  error = '',
}) => {
  const cellValue = getValue() ?? ''
  const [localValue, setLocalValue] = useState(cellValue)
  const isDisabled = table.options.meta?.disabled || extraDisable

  useEffect(() => {
    setLocalValue(cellValue)
  }, [cellValue])

  const onChange = ({ target: { value } }) => {
    if (!isNullish(value)) {
      setLocalValue(value)
    }
  }

  const onBlur = () => {
    // Avoid unnecessary table updates when value is unchanged; this prevents focus steal on next cell click.
    if (localValue !== cellValue) {
      // Defer update to the next tick so click-to-focus on the next cell can complete first.
      setTimeout(() => {
        table.options.meta?.updateData(rowIndex, columnId, localValue)
        handleOnBlur(rowIndex, columnId, localValue)
      }, 0)
    }
  }

  if (isDisabled) {
    return <Text>{localValue}</Text>
  }
  return (
    <>
      <Tooltip label={localValue}>
        <Input
          type={type}
          value={localValue}
          onChange={onChange}
          onBlur={onBlur}
          placeholder="Enter"
          borderColor={error !== '' ? 'red.500' : 'gray.200'}
        />
      </Tooltip>
      {error !== '' ? (
        <Text color={'red.500'} fontSize={'xs'} mt={1}>
          {error}
        </Text>
      ) : null}
    </>
  )
}

export default InputCell
